import * as XLSX from 'xlsx';
import {
  commitSweepRowsToFirestore,
  extractSweepFieldsFromRow,
  normVal,
  type ExtractedSweepRow,
  type ImportResult,
} from './sweepImportShared';

export type { ImportResult };

function readWorkbookFromArrayBuffer(buf: ArrayBuffer): XLSX.WorkBook {
  return XLSX.read(buf, { type: 'array' });
}

export async function importSweepLocationsFromXlsxArrayBuffer(opts: {
  masterOwnerID: string;
  ownerID?: string;
  arrayBuffer: ArrayBuffer;
  sweepFolderId?: string;
  sweepScheduledDate?: string;
}): Promise<ImportResult> {
  const masterOwnerID = normVal(opts.masterOwnerID);
  if (!masterOwnerID) throw new Error('masterOwnerID is required');
  const importBatchId = new Date().toISOString();

  const workbook = readWorkbookFromArrayBuffer(opts.arrayBuffer);
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) throw new Error('Excel file has no worksheets.');
  const sheet = workbook.Sheets[sheetName];
  if (!sheet) throw new Error('Could not read the first worksheet.');

  const rows = XLSX.utils.sheet_to_json<Record<string, unknown>>(sheet, {
    defval: '',
    raw: false,
  });

  const extracted: ExtractedSweepRow[] = [];
  let skipped = 0;

  for (const r of rows) {
    const ex = extractSweepFieldsFromRow(r);
    if (!ex) {
      skipped++;
      continue;
    }
    extracted.push(ex);
  }

  const { imported } = await commitSweepRowsToFirestore({
    masterOwnerID,
    ownerID: opts.ownerID,
    importBatchId,
    rows: extracted,
    forcedSweepFolderId: opts.sweepFolderId,
    forcedSweepScheduledDate: opts.sweepScheduledDate,
  });

  return { imported, skipped, errors: [], importBatchId };
}
